import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

export function getFheTickets(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllFheTickets(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_FHETICKETS`,
                        tickets: data.tickets
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheTickets - ', error);
                throw error;
            });
    };
}

export function getFheTicketDetails(env, ticketId) {
    return dispatch => {
        return apiCaller
            .call(api.getFheTicketDetails(env, ticketId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_FHETICKET_DETAILS`,
                        ticketId: ticketId,
                        ticket: data.ticket
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheTicketDetails - ', error);
                throw error;
            });
    };
}

export function updateFheTicketState(env, ticketId, ticketState) {
    return dispatch => {
        return apiCaller
            .call(api.updateFheTicketState(env, ticketId, ticketState))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_FHETICKET_STATE`,
                        ticketId: ticketId,
                        ticketState: ticketState
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateFheTicketState - ', error);
                throw error;
            });
    };
}

export function getFheTicketHistory(env, ticketId, offset, limit) {
    return () => {
        return apiCaller
            .call(api.getFheTicketHistory(env, ticketId, offset, limit))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheTicketHistory - ', error);
                throw error;
            });
    };
}

export function deleteFheTicketHistory(env, id, ticketId) {
    return () => {
        return apiCaller
            .call(api.deleteFheTicketHistory(env, id, ticketId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteFheTicketHistory - ', error);
                throw error;
            });
    };
}

export function addFheTicketHistoryMessage(env, ticketId, message) {
    return () => {
        return apiCaller
            .call(api.addFheTicketHistoryMessage(env, ticketId, message))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addFheTicketHistoryMessage - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/TicketFhe/actions.js